import { useTranslation } from 'react-i18next';
import { CardContainer } from '../CardContainer/CardContainer';
import { UserStatusSwitch } from '../UserStatusSwitch';

type UserStatusCardProps = {
  label?: string;
  status: boolean;
  handleStatus: (checked: boolean) => void;
  userId: number;
};

export const UserStatusCard = ({
  label,
  status,
  handleStatus,
  userId,
}: UserStatusCardProps) => {
  const { t } = useTranslation();
  return (
    <CardContainer>
      <span className="text-sm font-black">{label ?? t('status')}</span>
      <div className="flex w-24 items-center justify-end gap-2 text-sm">
        <span className={`${status ? 'text-blueNuit' : 'brightGray'}`}>
          {t(status ? 'active' : 'inactive')}
        </span>
        <UserStatusSwitch
          onChange={handleStatus}
          status={status}
          userId={userId}
        />
      </div>
    </CardContainer>
  );
};
